import { Button, Menu, MenuItem } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { ReactComponent as HelpIcon } from "../../assets/images/icon-help.svg";
import { FaqLinks, getUrlBasedOnCurrentLanguage } from "../../const/faqs-links";
import { IReduxAppState } from "../../reducers";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textDecoration: "none",
    },
    button: {
      margin: "0 1rem",
      "&:hover": {
        backgroundColor: "#455681",
        "& .logoutSVG path": {
          stroke: "#ffffff",
          transition: "stroke 0.3s ease",
        },
      },
      "&:active": {
        backgroundColor: "unset!important",
      },
    },
    menuItem: {
      minWidth: "150px",
    },
    helpButtonTitle: {
      marginRight: "0.5rem",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "#FFFFFF",
      display: "flex",
      justifyContent: "center",
      lineHeight: "0.875rem",
      "@media (max-width: 600px)": {
        display: "none",
      },
    },
    faqsOptionText: {
      alignItems: "center",
      justifyContent: "center",
      marginLeft: "0.5rem",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "0.875rem",
      lineHeight: "1.1875rem",
      color: "#737FA4",
    },
  })
);

const HelpButton = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const titleKey = useSelector(
    (state: IReduxAppState) => state.sidebar.position.key
  );

  return (
    <div>
      <Button
        id="helpButton"
        className={classes.button}
        name="Help"
        aria-label="help"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <div className={classes.helpButtonTitle}>{t("header.help")}</div>

        <HelpIcon />
      </Button>
      <Menu
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        id="fade-menu"
        anchorEl={document.getElementById("helpButton")}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <a
          className={classes.root}
          target="_blank"
          rel="noopener noreferrer"
          href={getUrlBasedOnCurrentLanguage(FaqLinks.MERCHANT_APP.key)}
        >
          <MenuItem className={classes.menuItem} onClick={() => {}}>
            <div className={classes.faqsOptionText}>{t("header.faq")}</div>
          </MenuItem>
        </a>

        {FaqLinks[titleKey]?.url && (
          <a
            className={classes.root}
            rel="noopener noreferrer"
            target="_blank"
            href={getUrlBasedOnCurrentLanguage(FaqLinks[titleKey].key)}
          >
            <MenuItem className={classes.menuItem} onClick={() => {}}>
              <div className={classes.faqsOptionText}>
                {t("header.helpPage")}
              </div>
            </MenuItem>
          </a>
        )}
      </Menu>
    </div>
  );
};

export default HelpButton;
